import type { AuthenticatedUser } from '@puffin/app-frame-api';
import { createContext, useContext } from 'react';

export const AuthenticatedUserContext = createContext<AuthenticatedUser | undefined>(undefined);

export const useAuthenticatedUser = () => useContext(AuthenticatedUserContext);
